import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import MoneyView from 'shared/components/MoneyView';
import SubmitButton from 'shared/components/SubmitButton';
import Tooltip from 'shared/components/Tooltip';
import { AnimateOverlay } from 'components/AnimateOverlay';
import { ErrorDescription } from 'shared/utils/formatError';
import { usePrice } from './hooks';

import './index.scss';

export interface Props {
  stockId: number;
  quantity: number;
  disabled?: boolean;
  submitting?: boolean;
  error?: ErrorDescription | string;
}

const b = b_.with('stock-submit-button');

export const Button: React.FC<Props> = ({ stockId, quantity, disabled, submitting, error }) => {
  const { t } = useTranslation();

  const { loading, cost } = usePrice(stockId, quantity);

  return (
    <AnimateOverlay isVisible={!disabled && (!cost || loading)}>
      <Tooltip
        placement="top"
        trigger={!disabled && !cost ? ['hover'] : []}
        overlay={
          <div className={`rc-overlay ${b('tooltip')}`}>{t('Cannot get current price short')}</div>
        }
      >
        <div>
          <SubmitButton
            disabled={!cost || disabled || loading}
            className={b('submit')}
            submitting={submitting}
            error={error}
            notificationWidth={400}
          >
            {t('Invest')}
            {cost && (
              <MoneyView className={b('cost')} placeholder="">
                {cost}
              </MoneyView>
            )}
          </SubmitButton>
        </div>
      </Tooltip>
    </AnimateOverlay>
  );
};
